import { gql } from "@apollo/client";

const GET_ORDER_ACS_SETTING = gql`
  query getACSSetting {
    getACSSetting {
      status
      error
      data {
        userName
        password
        updatedAt
      }
    }
  }
`;

export default GET_ORDER_ACS_SETTING;
